/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Existing_Step1Inputs */

const en_existing_step1 = /** @type {(inputs: Existing_Step1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy the prompt`)
};

const id_existing_step1 = /** @type {(inputs: Existing_Step1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salin prompt`)
};

/**
* | output |
* | --- |
* | "Copy the prompt" |
*
* @param {Existing_Step1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const existing_step1 = /** @type {((inputs?: Existing_Step1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Existing_Step1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_existing_step1(inputs)
	return en_existing_step1(inputs)
});